import { createContext, use } from 'react';

export interface ProductScope {
  /** The person may not change the product: the card shows its values, no inputs, no modal. */
  readOnly: boolean;
  /** The card is on a store's page and holds the master product: a change reaches every store. */
  shared?: boolean;
  /** The master product, for the "Edit on master" links. */
  productId?: string;
  /** The store's name, for what "This store" means. */
  storeName?: string;
  /** How many stores sell the product, for what "Shared" means. */
  storeCount?: number;
}

const ProductScopeContext = createContext<ProductScope>({ readOnly: false });

/** The store product page wraps its cards in this; the master page only when read-only. */
export const ProductScopeProvider = ProductScopeContext.Provider;

export const useProductScope = () => use(ProductScopeContext);
